import React from 'react'
import style from './style.module.scss'

const Footer = () => {
  return (
    <div className={style.footer}>
      <div className={style.footerInner}>
        <a
          href="https://www.proconnect.co.in"
          target="_blank"
          rel="noopener noreferrer"
          className={style.logo}
        >
          ConnectOne v2.2.0
          <span />
        </a>

        <p className="mb-0">
          Copyright © 2020 Proconnect Supply Chain Solutions Ltd |{' '}
          <a href="https://www.proconnect.co.in" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  )
}

export default Footer
